module.exports = __webpack_public_path__ + "static/media/uoa-5.0b66412b.jpg";